const getApiUrl = () => {
  // Check if we're running on localhost:3000 or localhost:3001 (development)
  if (window.location.hostname === 'localhost' && (window.location.port === '3000' || window.location.port === '3001')) {
    return 'http://localhost:8000';
  }
  
  // Check if we're in production environment
  if (process.env.NODE_ENV === 'production') {
    return 'https://promptparker.onrender.com';
  }
  
  // Fallback to environment variable or default
  return process.env.REACT_APP_API_URL || 'http://localhost:8000';
};

export const API_URL = getApiUrl();

// Log the API URL for debugging
console.log('API URL:', API_URL);

